import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyItFailsSection } from './components/WhyItFailsSection';
import { LoopMapSection } from './components/LoopMapSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { WhoItsForSection } from './components/WhoItsForSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1125345606305890');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Meta Pixel noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1125345606305890&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <main className="min-h-screen w-full bg-[#0a0e1a] text-[#e8e0d4] overflow-x-hidden selection:bg-[#c9a96e] selection:text-[#0a0e1a]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <WhyItFailsSection data-id="element-3" />
      <LoopMapSection data-id="element-4" />
      <WhatsInsideSection data-id="element-5" />
      <DifferentiatorSection data-id="element-6" />
      <WhoItsForSection data-id="element-7" />
      <ClosingSection data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}